import {
	CreateDrawerFormProps,
	FormDrawerContentProps,
	I18nFormDrawer,
	I18nFormDrawerContent,
	I18nFormFetchDrawer,
	I18nOnlyOnMainForm,
	I18nTextField,
	UpdateDrawerFormProps,
	useDynamicConfig,
	validateEachLanguage,
} from "@dgs/core";
import { FormikErrors } from "formik";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { tagService } from "../shared/api";
import { CategorySingleSelect } from "../shared/select/CategorySingleSelect";
import { TagFormValues, TagTranslationEntry, TagUpdateResource } from "../shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: TagFormValues) => {
		const errors: Record<string, any> = {};

		return {
			...errors,
			...validateEachLanguage(values.translations, (_, translation) => {
				const errors: FormikErrors<TagTranslationEntry> = {};
				if (!translation.name) {
					errors.name = t("Required field");
				}
				return errors;
			}),
		};
	};
};
const emptyTranslation = { name: "" };

const TagFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<I18nFormDrawerContent {...props} emptyTranslation={emptyTranslation}>
			<I18nTextField name="name" label={t("Name")} required="onlyOnMainForm" />
			<I18nOnlyOnMainForm>
				<CategorySingleSelect name="category" label={t("Category")} />
			</I18nOnlyOnMainForm>
		</I18nFormDrawerContent>
	);
};

export const TagCreateDrawer: FC<CreateDrawerFormProps<TagFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const { languageSettings } = useDynamicConfig();

	const initialValues: TagUpdateResource = useMemo(
		() => ({
			id: -1,
			category: null,
			translations: [{ locale: languageSettings.fallback, name: "" }],
		}),
		[languageSettings.fallback],
	);

	return (
		<I18nFormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Create tag")}
			validate={validate}
			renderForm={(formProps) => <TagFormDrawerContent {...formProps} {...props} />}
		/>
	);
};

export const TagUpdateDrawer: FC<UpdateDrawerFormProps<TagFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<I18nFormFetchDrawer
			{...props}
			title={t("Edit tag")}
			queryFn={() => tagService.show(props.id).then((x) => x.data.data)}
			queryKey={tagService.showKey(props.id)}
			validate={validate}
			renderSuccess={(formProps) => <TagFormDrawerContent {...props} {...formProps} />}
		/>
	);
};
